import frappe from '../frappe';

// Crea un Delivery Note a partir de una Sales Order
export const createOrderShipment = async (orderId, warehouseId) => {
  try {
    const { data } = await frappe.post(
      '/api/method/erpnext.selling.doctype.sales_order.sales_order.make_delivery_note',
      { source_name: orderId }
    );

    const dnDoc = data.message;
    dnDoc.set_warehouse = warehouseId;

    const { data: saved } = await frappe.post('/api/resource/Delivery%20Note', dnDoc);
    return saved.data.name;
  } catch (error) {
    console.error('Error al crear el shipment:', error.response?.data || error.message);
    return null;
  }
};

// Valida (submits) un Delivery Note
export const validateShipment = async (shipmentId) => {
  try {
    const { data } = await frappe.post('/api/method/frappe.client.submit', {
      doc: { doctype: 'Delivery Note', name: shipmentId },
    });
    return data.message;
  } catch (error) {
    console.error('Error al validar shipment:', error.response?.data || error.message);
    return null;
  }
};

// En Frappe el Delivery Note se cierra automáticamente al facturarlo
export const closeShipment = async (shipmentId) => {
  try {
    const { data } = await frappe.put(`/api/resource/Delivery%20Note/${shipmentId}`, {
      status: 'Closed',
    });
    return data.data;
  } catch (error) {
    console.error('Error al cerrar shipment:', error.response?.data || error.message);
    return null;
  }
};

// Busca el Delivery Note asociado a una Sales Order
export async function getShipmentsBySocid(customerId, orderId) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Delivery%20Note%20Item?filters=[["against_sales_order","=","${orderId}"]]&fields=["parent"]&limit=1`
    );

    if (data.data.length === 0) return null;
    return data.data[0].parent;
  } catch (error) {
    if (error.response?.status === 404) return null;
    console.error('Error al obtener envíos:', error.response?.data || error.message);
    throw error;
  }
}
